"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WebformViewContext = exports.WebformViewConsumer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _recompose = require("recompose");
var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ButtonInput = _interopRequireDefault(require("../../Input/ButtonInput/ButtonInput"));
var _Text = require("../../Text/Text");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _colors = require("../../style/colors");
var _excluded = ["autoComplete", "buttonClassName", "buttonColorScheme", "children", "classes", "className", "disabled", "displayErrors", "error", "hasSubmit", "id", "implicitSubmission", "loading", "noValidate", "onSubmit", "readOnly", "rootRef", "submit", "theme"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    errorMessage: theme.mixins.inputErrorMessage,
    submit: theme.mixins.inputMargin,
    button: theme.mixins.formButton
  };
};
/*:: type ContextValue = {
  disabled: boolean,
  displayErrors: boolean,
  loading: boolean,
  readOnly: boolean,
  setDisplayErrorsState: (...args: Array<any>) => any,
  setLoadingState: (...args: Array<any>) => any
};*/
var defaultContextValue = {
  disabled: false,
  displayErrors: false,
  loading: false,
  readOnly: false,
  setDisplayErrorsState: function setDisplayErrorsState() {},
  setLoadingState: function setLoadingState() {}
};
var WebformViewContext /*: React.Context<ContextValue>*/ = exports.WebformViewContext = React.createContext(defaultContextValue);
/*:: type Props = InjectSheetProvidedProps & {
  autoComplete: string,
  buttonClassName?: string,
  buttonColorScheme: string,
  children: React.Node,
  disabled: boolean,
  displayErrors: boolean,
  error?: Error,
  hasSubmit: boolean,
  id: string,
  implicitSubmission?: boolean,
  loading: boolean,
  noValidate: boolean,
  onSubmit?: (
    event: SyntheticEvent<HTMLFormElement>,
    formData: FormData
  ) => mixed,
  readOnly: boolean,
  rootRef?: React.Ref<*>,
  submit?: string | React.Element<typeof FormattedMessage>
};*/
/*:: type State = {
  displayErrors: boolean,
  loading: boolean
};*/
var WebformView = /*#__PURE__*/function (_React$PureComponent) {
  function WebformView() {
    var _this;
    (0, _classCallCheck2.default)(this, WebformView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WebformView, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      displayErrors: _this.props.displayErrors,
      loading: _this.props.loading
    });
    (0, _defineProperty2.default)(_this, "handleSubmit", function (event /*: SyntheticEvent<HTMLFormElement>*/) {
      event.preventDefault();
      event.stopPropagation();
      var currentTarget = event.currentTarget;
      var form = currentTarget || {};
      var invalidInput = form.querySelector('[data-error], :invalid');
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        onSubmit = _this$props.onSubmit;
      var loading = _this.state.loading;
      if (disabled || loading) {
        // Don't call `onSubmit` if form is disabled or loading
        return;
      }
      if (invalidInput) {
        var name = invalidInput.getAttribute('data-name');

        // Scroll invalid input into view
        (0, _scrollIntoViewIfNeeded.default)((name ? form.querySelector("[data-id=\"".concat(name, "\"]")) : invalidInput) || form, {
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
          scrollMode: 'if-needed'
        });
        _this.setState({
          displayErrors: true
        });

        // Don't call `onSubmit` if input is invalid
        return;
      }
      _this.setState({
        displayErrors: false
      });
      if (typeof onSubmit === 'function') {
        return onSubmit(event, new FormData(form));
      }
    });
    (0, _defineProperty2.default)(_this, "setDisplayErrorsState", function (displayErrors /*: boolean*/) {
      return _this.setState({
        displayErrors: displayErrors
      });
    });
    (0, _defineProperty2.default)(_this, "setLoadingState", function (loading /*: boolean*/) {
      return _this.setState({
        loading: loading
      });
    });
    return _this;
  }
  (0, _inherits2.default)(WebformView, _React$PureComponent);
  return (0, _createClass2.default)(WebformView, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref /*:: */) {
      var prevDisplayErrors = _ref /*:: */.displayErrors,
        prevLoading = _ref /*:: */.loading;
      var _this$props2 = this.props,
        displayErrors = _this$props2.displayErrors,
        loading = _this$props2.loading;
      if (prevDisplayErrors !== displayErrors) {
        this.setState({
          displayErrors: displayErrors
        });
      }
      if (prevLoading !== loading) {
        this.setState({
          loading: loading
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        autoComplete = _this$props3.autoComplete,
        buttonClassName = _this$props3.buttonClassName,
        buttonColorScheme = _this$props3.buttonColorScheme,
        children = _this$props3.children,
        classes = _this$props3.classes,
        className = _this$props3.className,
        disabled = _this$props3.disabled,
        displayErrorsProp = _this$props3.displayErrors,
        errorProp = _this$props3.error,
        hasSubmit = _this$props3.hasSubmit,
        id = _this$props3.id,
        implicitSubmission = _this$props3.implicitSubmission,
        loadingProp = _this$props3.loading,
        noValidate = _this$props3.noValidate,
        onSubmit = _this$props3.onSubmit,
        readOnly = _this$props3.readOnly,
        rootRef = _this$props3.rootRef,
        submit = _this$props3.submit,
        theme = _this$props3.theme,
        other = (0, _objectWithoutProperties2.default)(_this$props3, _excluded);
      var _this$state = this.state,
        displayErrors = _this$state.displayErrors,
        loading = _this$state.loading;
      var error = errorProp && errorProp.message ? errorProp.message : errorProp;
      return /*#__PURE__*/React.createElement("form", (0, _extends2.default)({
        autoComplete: autoComplete,
        className: className,
        "data-testid": "webformview",
        id: id,
        noValidate: noValidate,
        onSubmit: this.handleSubmit,
        ref: rootRef
      }, other), !implicitSubmission && /*#__PURE__*/React.createElement("button", {
        type: "submit",
        "data-testid": "button-false-submit",
        disabled: true,
        style: {
          display: 'none'
        },
        "aria-hidden": "true"
      }), error && /*#__PURE__*/React.createElement("div", {
        className: classes.errorMessage
      }, /*#__PURE__*/React.createElement(_Text.BaseText, null, String(error))), /*#__PURE__*/React.createElement(WebformViewContext.Provider, {
        value: {
          disabled: disabled,
          displayErrors: displayErrors,
          loading: loading,
          readOnly: readOnly,
          setDisplayErrorsState: this.setDisplayErrorsState,
          setLoadingState: this.setLoadingState
        }
      }, children), hasSubmit && !disabled && /*#__PURE__*/React.createElement("div", {
        className: classes.submit
      }, /*#__PURE__*/React.createElement(_ButtonInput.default, {
        className: (0, _classnames.default)(classes.button, buttonClassName),
        colorScheme: buttonColorScheme || _colors.SCIENCE_BLUE,
        disabled: disabled,
        loading: loading,
        readOnly: readOnly,
        "data-testid": "button-webform-submit",
        type: "submit"
      }, submit || /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
        defaultMessage: "Submit",
        description: "Webform submit button",
        id: "webform.submit"
      }))));
    }
  }]);
}(React.PureComponent); // TODO: type props to withForwardRef component
(0, _defineProperty2.default)(WebformView, "displayName", 'WebformView');
(0, _defineProperty2.default)(WebformView, "defaultProps", {
  autoComplete: 'on',
  disabled: false,
  displayErrors: false,
  hasSubmit: true,
  loading: false,
  noValidate: true,
  readOnly: false
});
/*:: type EnhancedProps = Object;*/
var withForwardRef = function withForwardRef(Component) {
  return ((0, _recompose.compose)(
  // TODO: Fix Flow error
  // Possibly related: https://medium.com/flow-type/asking-for-required-annotations-64d4f9c1edf8
  (0, _recompose.setDisplayName)("withForwardRef(".concat(Component.displayName || 'WebformView')), React.forwardRef)(function (props, ref) {
    return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
      rootRef: ref
    }, props));
  }) /*: React.ComponentType<EnhancedProps>*/);
};
var _default = exports.default = (0, _recompose.compose)(withForwardRef, (0, _injectSheet.default)(Style))(WebformView);
var WebformViewConsumer = exports.WebformViewConsumer = WebformViewContext.Consumer;
//# sourceMappingURL=WebformView.js.map